import { lazy } from 'react';




//sets the pages display settings

const ConfirmAssetDispatchAppConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/asset-dispatch-confirm/:id/:driver_id/:queue/:asset_length?',
      component: lazy(() => import('./ConfirmAssetDispatchApp')),
    },
  ],
};

export default ConfirmAssetDispatchAppConfig
